// Each team's primary brand color, used as a subtle accent (border + light
// tint) when a user's active/undecided pick is that team -- see
// EnterPicks.js/Admin.js. Picked deliberately for contrast/visibility rather
// than a team's literal darkest or lightest official color (e.g. Raiders use
// their silver, not black; Jaguars use gold, not black).
const teamColors = {
    'Bears': '#0B162A',
    'Bengals': '#FB4F14',
    'Bills': '#00338D',
    'Broncos': '#FB4F14',
    'Browns': '#FF3C00',
    'Buccaneers': '#D50A0A',
    'Cardinals': '#97233F',
    'Chargers': '#0080C6',
    'Chiefs': '#E31837',
    'Colts': '#002C5F',
    'Commanders': '#5A1414',
    'Cowboys': '#041E42',
    'Dolphins': '#008E97',
    'Eagles': '#004C54',
    'Falcons': '#A71930',
    'Giants': '#0B2265',
    'Jaguars': '#D7A22A',
    'Jets': '#125740',
    'Lions': '#0076B6',
    'Niners': '#AA0000',
    'Packers': '#203731',
    'Panthers': '#0085CA',
    'Patriots': '#002244',
    'Raiders': '#A5ACAF',
    'Rams': '#003594',
    'Ravens': '#241773',
    'Saints': '#D3BC8D',
    'Seahawks': '#69BE28',
    'Steelers': '#FFB612',
    'Texans': '#A71930',
    'Titans': '#4B92DB',
    'Vikings': '#4F2683',
};

export default teamColors;
